import { render, staticRenderFns } from "./MaterialTypeEdit.vue?vue&type=template&id=4ea3c110&scoped=true&"
import script from "./MaterialTypeEdit.vue?vue&type=script&lang=js&"
export * from "./MaterialTypeEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ea3c110",
  null
  
)

export default component.exports